import React from 'react';
import { ClassAssembly7A2026 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly7A2026/>;
  };
  
  export default ClassAssemblyPage;